'use strict'

class CXPointsResultArray {
    constructor(width) {
        this._pointsArray = new Map()
        this._imageWidth = width
    }

    /**
     * Getter points array
     *
     * @memberof CXPointsArraySimple return points arary
     */
    get pointsArray() {
        return this._pointsArray
    }

    /**
     * Add new points to array
     * @param {*} x x coordinate
     * @param {*} y y coordinate
     * @param {*} level level
     * @param {*} isSurounded is the pixel surrounded
     */
    addPoint(x = x, y = y) {
        this._pointsArray.set(y * this._imageWidth + x, {
            x: x,
            y: y,
        })
    }
}
export default CXPointsResultArray
